// @ts-nocheck
/**
 * chat-autosuggest.js — Text autosuggest for chat input.
 *
 * Uses:
 * - Canonical terms from window.AIFlorist.suggestLib
 * - Live names from GET /flower-library manifest (if available)
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};
  var debug = window.AIFlorist.debug || { log: function () {}, warn: function () {}, error: function () {} };

  var workerUrl = '';
  var inputEl = null;
  var inputAreaEl = null;
  var dropdownEl = null;
  var candidates = [];
  var isOpen = false;
  var activeIndex = -1;
  var items = [];
  var hideTimer = null;
  var suggestLib = null;
  var hasLiveAvailability = false;
  var suggestionsEnabled = false;
  var toggleInputEl = null;
  var ENABLE_KEY = 'afc_autosuggest_enabled';

  function init(deps) {
    workerUrl = (deps && deps.workerUrl) || '';
    inputEl = deps && deps.inputEl;
    if (!inputEl) return;

    suggestLib = (deps && deps.suggestLib) || window.AIFlorist.suggestLib || null;
    inputAreaEl = inputEl.closest('.afc-input-area');
    if (!inputAreaEl) return;
    suggestionsEnabled = loadSuggestionsEnabled();

    buildDropdown();
    buildPreferenceToggle();
    rebuildCandidates();
    if (suggestionsEnabled) {
      hydrateLiveAvailabilityNames();
    }
    bindEvents();
  }

  function buildDropdown() {
    dropdownEl = document.createElement('div');
    dropdownEl.className = 'afc-autosuggest';
    dropdownEl.setAttribute('role', 'listbox');
    dropdownEl.style.display = 'none';
    inputAreaEl.appendChild(dropdownEl);
  }

  function bindEvents() {
    inputEl.addEventListener('input', handleInput);
    inputEl.addEventListener('focus', handleInput);
    inputEl.addEventListener('blur', scheduleHide);
    inputEl.addEventListener('keydown', handleKeydown);
    document.addEventListener('click', handleDocumentClick);
    window.addEventListener('resize', updateDropdownPosition);
  }

  function buildPreferenceToggle() {
    var uploadBtn = inputAreaEl.querySelector('#afc-upload-btn');
    if (!uploadBtn) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'afc-autosuggest-toggle' + (suggestionsEnabled ? ' afc-autosuggest-toggle--on' : '');
    btn.title = suggestionsEnabled ? 'Suggestions on' : 'Suggestions off';
    btn.setAttribute('aria-pressed', String(suggestionsEnabled));
    btn.innerHTML =
      '<svg class="afc-autosuggest-toggle-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>' +
        '<line x1="9" y1="10" x2="15" y2="10"></line>' +
      '</svg>' +
      '<span class="afc-autosuggest-toggle-label">Suggest</span>';

    function syncToggleVisual() {
      if (suggestionsEnabled) {
        btn.classList.add('afc-autosuggest-toggle--on');
      } else {
        btn.classList.remove('afc-autosuggest-toggle--on');
      }
      btn.title = suggestionsEnabled ? 'Suggestions on' : 'Suggestions off';
      btn.setAttribute('aria-pressed', String(suggestionsEnabled));
    }

    var lastToggleAt = 0;
    function doToggle(e) {
      e.preventDefault();
      e.stopPropagation();
      var now = Date.now();
      if (now - lastToggleAt < 300) return;
      lastToggleAt = now;
      setSuggestionsEnabled(!suggestionsEnabled, true);
      syncToggleVisual();
    }
    btn.addEventListener('touchend', doToggle, { passive: false });
    btn.addEventListener('click', doToggle);
    toggleInputEl = btn;
    uploadBtn.parentNode.insertBefore(btn, uploadBtn);
  }

  function handleInput() {
    if (!suggestionsEnabled) {
      closeDropdown();
      return;
    }
    clearTimeout(hideTimer);
    var token = getActiveToken();
    if (!token.query || token.query.length < 1) {
      closeDropdown();
      return;
    }
    renderSuggestions(token.query, token.compoundQuery);
  }

  function handleKeydown(e) {
    if (!suggestionsEnabled) return;
    if (!isOpen || !items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      e.stopPropagation();
      if (activeIndex < 0) {
        activeIndex = 0;
      } else if (activeIndex >= items.length - 1) {
        // Exit suggestion selection at list end instead of looping.
        activeIndex = -1;
      } else {
        activeIndex += 1;
      }
      paintActive();
      return;
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      e.stopPropagation();
      activeIndex = (activeIndex - 1 + items.length) % items.length;
      paintActive();
      return;
    }

    if (e.key === 'Tab') {
      // Tab should never auto-apply a suggestion.
      e.preventDefault();
      e.stopPropagation();
      activeIndex = -1;
      closeDropdown();
      if (inputEl && typeof inputEl.focus === 'function') {
        inputEl.focus();
      }
      return;
    }

    if (e.key === 'Enter') {
      var chosen = activeIndex >= 0 ? items[activeIndex] : null;
      if (!chosen) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      applySuggestion(chosen.term);
      return;
    }

    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeDropdown();
    }
  }

  function handleDocumentClick(e) {
    if (!dropdownEl || !inputAreaEl) return;
    var target = e.target;
    if (dropdownEl.contains(target) || inputAreaEl.contains(target)) return;
    closeDropdown();
  }

  function scheduleHide() {
    hideTimer = setTimeout(closeDropdown, 140);
  }

  function renderSuggestions(rawQuery, rawCompoundQuery) {
    if (!suggestionsEnabled) return;
    if (!dropdownEl) return;

    var query = normalize(rawQuery);
    var compoundQuery = normalize(rawCompoundQuery || '');
    var ranked = rankCandidates(query, compoundQuery).slice(0, 6);
    if (!ranked.length) {
      closeDropdown();
      return;
    }

    items = ranked;
    activeIndex = -1;

    var html = '';
    for (var i = 0; i < ranked.length; i++) {
      html +=
        '<button type="button" class="afc-autosuggest-item" data-idx="' + i + '">' +
          '<span class="afc-autosuggest-item-text">' + escapeHtml(ranked[i].term) + '</span>' +
        '</button>';
    }
    dropdownEl.innerHTML = html;

    var btns = dropdownEl.querySelectorAll('.afc-autosuggest-item');
    for (var b = 0; b < btns.length; b++) {
      btns[b].addEventListener('mousedown', handleSuggestionClick);
    }

    openDropdown();
  }

  function handleSuggestionClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var idx = parseInt(e.currentTarget.getAttribute('data-idx') || '-1', 10);
    if (idx < 0 || !items[idx]) return;
    applySuggestion(items[idx].term);
  }

  function applySuggestion(term) {
    if (!inputEl) return;
    var token = getActiveToken();
    if (!token.query) return;

    var val = inputEl.value || '';
    var next =
      val.slice(0, token.replaceStart) +
      term +
      ' ' +
      val.slice(token.caret);

    inputEl.value = next;
    var caret = token.replaceStart + term.length + 1;
    inputEl.setSelectionRange(caret, caret);
    inputEl.dispatchEvent(new Event('input', { bubbles: true }));
    closeDropdown();
  }

  function getActiveToken() {
    if (!inputEl) return { query: '', replaceStart: 0, caret: 0 };
    var val = inputEl.value || '';
    var caret = typeof inputEl.selectionStart === 'number' ? inputEl.selectionStart : val.length;

    var start = caret;
    while (start > 0 && isWordChar(val.charAt(start - 1))) start--;
    var trimmed = val.slice(start, caret).trim();

    // Previous word gives phrase context (e.g. "white tu" -> "white tulips")
    var prevEnd = start;
    while (prevEnd > 0 && /\s/.test(val.charAt(prevEnd - 1))) prevEnd--;
    var prevStart = prevEnd;
    while (prevStart > 0 && isWordChar(val.charAt(prevStart - 1))) prevStart--;
    var prevWord = val.slice(prevStart, prevEnd).trim();
    var compound = prevWord && trimmed ? (prevWord + ' ' + trimmed) : '';

    return {
      query: trimmed,
      compoundQuery: compound,
      replaceStart: start,
      caret: caret,
    };
  }

  function rankCandidates(query, compoundQuery) {
    var out = [];
    for (var i = 0; i < candidates.length; i++) {
      var term = candidates[i];
      var score = scoreTerm(term, query);
      if (compoundQuery) {
        // Phrase-context score should dominate single-token matches when relevant.
        score = Math.max(score, scoreTerm(term, compoundQuery) + 6);
      }
      if (score <= 0) continue;
      out.push({ term: term, score: score });
    }
    out.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.term.localeCompare(b.term);
    });
    return out;
  }

  function scoreTerm(term, query) {
    var t = normalize(term);
    if (!t || !query) return 0;
    if (t === query) return 120;
    if (t.indexOf(query) === 0) return 100;
    if ((' ' + t).indexOf(' ' + query) !== -1) return 82;
    if (t.indexOf(query) !== -1) return 70;
    if (query.length >= 4) {
      var dist = levenshtein(t, query, 2);
      if (dist <= 2) return 48 - dist * 10;
    }
    return 0;
  }

  function levenshtein(a, b, max) {
    var m = a.length;
    var n = b.length;
    if (Math.abs(m - n) > max) return max + 1;
    var dp = [];
    for (var i = 0; i <= n; i++) dp[i] = i;
    for (var r = 1; r <= m; r++) {
      var prev = dp[0];
      dp[0] = r;
      var rowMin = dp[0];
      for (var c = 1; c <= n; c++) {
        var tmp = dp[c];
        var cost = a.charAt(r - 1) === b.charAt(c - 1) ? 0 : 1;
        dp[c] = Math.min(dp[c] + 1, dp[c - 1] + 1, prev + cost);
        prev = tmp;
        if (dp[c] < rowMin) rowMin = dp[c];
      }
      if (rowMin > max) return max + 1;
    }
    return dp[n];
  }

  function rebuildCandidates(liveNames) {
    var lib = suggestLib && suggestLib.getLibrary ? suggestLib.getLibrary() : null;
    var merged = [];
    if (lib && lib.colors) {
      merged = merged.concat(lib.colors || []);
    }
    if (liveNames && liveNames.length) {
      hasLiveAvailability = true;
      merged = merged.concat(liveNames);
    } else if (lib) {
      merged = merged
        .concat(lib.flowerTypes || [])
        .concat(lib.inventoryFlowerTerms || [])
        .concat(lib.phraseStarters || [])
        .concat(lib.generatedColorFlowerPhrases || []);
    }
    candidates = dedupe(merged);
  }

  function hydrateLiveAvailabilityNames() {
    if (!workerUrl) return;
    var cache = loadAvailabilityCache();
    if (cache) {
      rebuildCandidates(cache);
      return;
    }

    var availabilityXhr = new XMLHttpRequest();
    availabilityXhr.open('GET', workerUrl + '/flower-availability');
    availabilityXhr.onload = function () {
      if (availabilityXhr.status !== 200) {
        hydrateFallbackManifestNames();
        return;
      }
      try {
        var payload = JSON.parse(availabilityXhr.responseText);
        var names = dedupe((payload && payload.names) || []);
        saveAvailabilityCache(names);
        rebuildCandidates(names);
      } catch (e) {
        debug.warn('[Autosuggest] Failed to parse flower-availability payload', e);
        hydrateFallbackManifestNames();
      }
    };
    availabilityXhr.onerror = hydrateFallbackManifestNames;
    availabilityXhr.send();
  }

  function hydrateFallbackManifestNames() {
    if (hasLiveAvailability) return;
    var cache = loadManifestCache();
    if (cache) {
      rebuildCandidates(extractManifestNames(cache));
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', workerUrl + '/flower-library');
    xhr.onload = function () {
      if (xhr.status !== 200) return;
      try {
        var manifest = JSON.parse(xhr.responseText);
        saveManifestCache(manifest);
        rebuildCandidates(extractManifestNames(manifest));
      } catch (e) {
        debug.warn('[Autosuggest] Failed to parse flower-library manifest', e);
      }
    };
    xhr.send();
  }

  function loadAvailabilityCache() {
    try {
      var raw = localStorage.getItem('afc_autosuggest_available_names');
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.ts || !entry.data) return null;
      if (Date.now() - entry.ts > 300000) return null;
      return Array.isArray(entry.data) ? entry.data : null;
    } catch (e) {
      return null;
    }
  }

  function saveAvailabilityCache(names) {
    try {
      localStorage.setItem('afc_autosuggest_available_names', JSON.stringify({ ts: Date.now(), data: names }));
    } catch (e) {}
  }

  function setSuggestionsEnabled(enabled, skipFocus) {
    suggestionsEnabled = !!enabled;
    saveSuggestionsEnabled(suggestionsEnabled);
    if (!suggestionsEnabled) {
      closeDropdown();
      return;
    }
    if (!skipFocus && inputEl && typeof inputEl.focus === 'function') {
      inputEl.focus();
    }
    if (!hasLiveAvailability) {
      hydrateLiveAvailabilityNames();
    }
    handleInput();
  }

  function loadSuggestionsEnabled() {
    try {
      var raw = localStorage.getItem(ENABLE_KEY);
      if (raw == null) return false;
      return raw === '1';
    } catch (e) {
      return false;
    }
  }

  function saveSuggestionsEnabled(enabled) {
    try {
      localStorage.setItem(ENABLE_KEY, enabled ? '1' : '0');
    } catch (e) {}
  }

  function extractManifestNames(manifest) {
    var names = [];
    var categories = (manifest && manifest.categories) || [];
    for (var i = 0; i < categories.length; i++) {
      var subcategories = categories[i].subcategories || [];
      for (var j = 0; j < subcategories.length; j++) {
        var arr = subcategories[j].items || [];
        for (var k = 0; k < arr.length; k++) {
          if (arr[k] && arr[k].name) names.push(arr[k].name);
        }
      }
    }
    return dedupe(names);
  }

  function loadManifestCache() {
    try {
      var raw = localStorage.getItem('afc_autosuggest_manifest');
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.ts || !entry.data) return null;
      if (Date.now() - entry.ts > 3600000) return null;
      return entry.data;
    } catch (e) {
      return null;
    }
  }

  function saveManifestCache(data) {
    try {
      localStorage.setItem('afc_autosuggest_manifest', JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  function openDropdown() {
    if (!dropdownEl) return;
    updateDropdownPosition();
    dropdownEl.style.display = 'block';
    isOpen = true;
  }

  function closeDropdown() {
    if (!dropdownEl) return;
    dropdownEl.style.display = 'none';
    dropdownEl.innerHTML = '';
    isOpen = false;
    items = [];
    activeIndex = -1;
  }

  function updateDropdownPosition() {
    if (!dropdownEl || !inputEl || !inputAreaEl || !isOpen) return;
    var areaRect = inputAreaEl.getBoundingClientRect();
    var inputRect = inputEl.getBoundingClientRect();
    var bottom = areaRect.bottom - inputRect.top + 8;

    if (toggleInputEl && window.innerWidth < 768) {
      var toggleRect = toggleInputEl.getBoundingClientRect();
      if (toggleRect.height > 0) {
        bottom += toggleRect.height + 6;
      }
    }

    dropdownEl.style.left = (inputRect.left - areaRect.left) + 'px';
    dropdownEl.style.width = inputRect.width + 'px';
    dropdownEl.style.bottom = bottom + 'px';
  }

  function paintActive() {
    if (!dropdownEl) return;
    var btns = dropdownEl.querySelectorAll('.afc-autosuggest-item');
    for (var i = 0; i < btns.length; i++) {
      if (i === activeIndex) {
        btns[i].classList.add('afc-autosuggest-item--active');
        btns[i].scrollIntoView({ block: 'nearest' });
      } else {
        btns[i].classList.remove('afc-autosuggest-item--active');
      }
    }
  }

  function dedupe(values) {
    var seen = {};
    var out = [];
    for (var i = 0; i < values.length; i++) {
      var raw = String(values[i] || '').trim();
      if (!raw) continue;
      var key = raw.toLowerCase();
      if (seen[key]) continue;
      seen[key] = true;
      out.push(raw);
    }
    return out;
  }

  function normalize(text) {
    var lower = String(text || '').trim().toLowerCase();
    return suggestLib && suggestLib.normalizeTerm ? suggestLib.normalizeTerm(lower) : lower;
  }

  function isWordChar(ch) {
    return /[A-Za-z']/i.test(ch || '');
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  window.AIFlorist.autosuggest = {
    init: init,
  };
})();
